import {React, useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './dashboard.module.css'
import constants from '../../../constants.js'
import api from '../../../routes/api.js'
import utils from '../../../utils/utils.js';

import { useApiProvider } from '../../../providers/ApiProvider.js';
import { useSidebarProvider } from '../../../providers/SidebarProvider.js';
import { useLeagueTypeProvider } from '../../../providers/LeagueTypeProvider';

import ReadOnlyTable from "../../common/ReadOnlyTable/ReadOnlyTable.js"

const filterMatchupsByWeek = (matchups, week) => {
  if (!matchups) return;

  let filteredMatchups = []

  if (typeof week == "string"){
    const playoffWeek = week[week.length-1];
    const playoffs = matchups.filter((m) => {
      return m[constants.playoffs] == true;
    })
    filteredMatchups = playoffs.filter((matchup) => {
      return matchup[constants.weekNumber] == playoffWeek;
    });

  }
  else {
    filteredMatchups = matchups.filter((matchup) => {
      return matchup[constants.weekNumber] == week && matchup[constants.playoffs] == false;
    });
  }

  return filteredMatchups;
}

const Matchups = ({
        teamStandings,
        allMatchups, selectedWeekMatchups, 
        selectedWeek, allWeeks,
        selectedLocation, selectedDivision,
        leagueType}) => {
  
  const navigate = useNavigate();
 
  const gotoLineup = (e) => {
    const matchup = allMatchups.find((m) => m[constants.matchupId] == e.currentTarget.id);
    navigate('/' + leagueType + '/matchup', { 
      replace: true,
      state: {
        selectedLocation: selectedLocation,
        selectedDivision: selectedDivision, 
        matchup: {
          matchupId: e.currentTarget.id,
          matchupDate: e.currentTarget.children[1].innerHTML,
          homeClub: matchup[constants.homeClub],
          homeTeamName: matchup[constants.homeName].toUpperCase(),
          homeTeamId: matchup[constants.homeTeamId],
          awayClub: matchup[constants.awayClub],
          awayTeamName: matchup[constants.awayName].toUpperCase(),
          awayTeamId: matchup[constants.awayTeamId],
        }
      }
    });
  }

  return (
    <div className={styles.MatchupsContainer}> 
      <div className={styles.MatchupsTitle}>
        {allMatchups.length === 0
          ? "Week 1 Matchups"
          : typeof selectedWeek == "string"
            ? constants.playoffRounds[
                constants.playoffRoundsShort.indexOf(
                  allWeeks[allWeeks.findIndex(w => w.value == selectedWeek)].label
                )
              ]
            : "Week " + selectedWeek + " Matchups"}
      </div>

      {allMatchups.length === 0 ? (
        <div className={styles.MatchupRow}>
          <div className={styles.MatchupTeams}>
            <div className={styles.TeamLogo}></div>

            <div className={styles.Team}>
            <div className={styles.TeamText}>Coming Soon!</div>
            </div>

            <div className={styles.Vs}>VS</div>

            <div className={styles.Team}>
            <div className={styles.TeamText}>Coming Soon!</div>
            </div>

            <div className={styles.TeamLogo}></div>
          </div>
        </div>
      ) : (
        selectedWeekMatchups.map((matchup) => {
          const awayTeam = teamStandings.find(t => t[constants.teamId] == matchup[constants.awayTeamId]);
          const homeTeam = teamStandings.find(t => t[constants.teamId] == matchup[constants.homeTeamId]);
          
          return (
            <div onClick={gotoLineup} className={styles.MatchupRow} id={matchup[constants.matchupId]} key={matchup[constants.id]}>
              <div className={styles.MatchupTeams}>

                <div className={styles.TeamLogo} style={{borderLeft: `2px solid ${constants.colors.cplYellow}` }}>
                  {awayTeam ? <img src={`/logos/${awayTeam[constants.clubLogo]}.png`} className={styles.Icon}/> : <></>}
                </div>

                <div id={matchup[constants.awayTeamId]} className={styles.Team} style={{justifyContent:'flex-start'}}>
                  <div className={styles.TeamText} style={{height:'2em', marginRight: '.5em', textAlign:'start'}}>
                    {awayTeam ? matchup[constants.awayName] + " (" + awayTeam[constants.ranking] + ")" : "BYE"}
                  </div> 
                </div>

                <div className={styles.Vs}>VS</div>

                <div id={matchup[constants.homeTeamId]} className={styles.Team} style={{justifyContent: 'flex-end'}}>
                  <div className={styles.TeamText} style={{height:'2em', marginRight: '.5em', textAlign:'end'}}>
                    {homeTeam ? matchup[constants.homeName] + " (" + homeTeam[constants.ranking] + ")" : "BYE"}
                  </div>
                </div>

                <div className={styles.TeamLogo} style={{borderRight: `2px solid ${constants.colors.cplYellow}` }}>
                  {homeTeam ? <img src={`/logos/${homeTeam[constants.clubLogo]}.png`} className={styles.Icon}/> : <></>}
                </div>
              </div>
              
              <div className={styles.MatchTime}>
                {new Date(matchup[constants.scheduledTime]).toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: true,
                }).replace(',', ' -')}
              </div>

              <div className={styles.MatchTime}>
                View lineup
              </div>
            </div>
          );
        })
      )}
    </div>
  )
}

const Overview = ({players, teams, setSelectedMenuItem}) => {
  const navigate = useNavigate();
  const { leagueType } = useLeagueTypeProvider();

  const onStandingsClick = () => {
    setSelectedMenuItem(constants.sidebarItems[3]);
    navigate('/' + leagueType + '/' + constants.sidebarItems[3], { replace: true });
  }

  const onStatisticsClick = () => {
    setSelectedMenuItem(constants.sidebarItems[2]);
    navigate('/' + leagueType + '/' + constants.sidebarItems[2], { replace: true });
  }

  return(
    <div className={styles.OverviewContainer}>
      <div className={styles.Table}>
        <ReadOnlyTable 
          headers={constants.table.dashboardPlayerCols}
          headerColor={constants.colors.cplWhite}
          tableKey={constants.playerId}
          tableData={players.slice(0, 9)}
          tableTitle={constants.standings}
          tableFooter={
            <span onClick={onStandingsClick} className={styles.Footer}>
              <a>{constants.moreStatistics}</a>
            </span>
        }/>
      </div>
      <div className={styles.Table}>
        <ReadOnlyTable 
          headers={constants.table.dashboardTeamCols}
          headerColor={constants.colors.cplWhite}
          tableKey={constants.teamId}
          tableData={teams.slice(0, 9)}
          tableTitle={constants.teamStandings}
          tableFooter={
            <span onClick={onStatisticsClick} className={styles.Footer}>
              <a>{constants.moreStandings}</a>
            </span>
        }/>
      </div>
    </div>
  )
}

const Dashboard = ({setSelectedMenuItem, selectedLocation, selectedDivision}) => {
  const { setIsSidebarShowing } = useSidebarProvider();
  const { setDialog, isLoading, setIsLoading, LoadingSpinner} = useApiProvider();
  const { leagueType } = useLeagueTypeProvider();

  const [playerStandings, setPlayerStandings] = useState([]);
  const [teamStandings, setTeamStandings] = useState([]);
  const [allMatchups, setAllMatchups] = useState([]);
  const [selectedWeekMatchups, setSelectedWeekMatchups] = useState([]);

  const [selectedWeek, setSelectedWeek] = useState();
  const [allWeeks, setAllWeeks] = useState();
  
  const getPreviousMonday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 (Sun) - 6 (Sat)

    // How many days to subtract to get to the most recent Monday
    // If today IS Monday (1), we want this Monday (0 days back)
    // If today is Sunday (0), we want 6 days back
    const daysBack = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

    const previousMonday = new Date(today);
    previousMonday.setDate(today.getDate() - daysBack);
    previousMonday.setHours(0, 0, 0, 0); // Start of day

    return previousMonday;
  };

  const getUpcomingMonday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();

    // Days until next Monday
    // If today IS Monday (1), we want 7 days ahead (next Monday, not today)
    const daysAhead = dayOfWeek === 1 ? 7 : (8 - dayOfWeek) % 7;

    const upcomingMonday = new Date(today);
    upcomingMonday.setDate(today.getDate() + daysAhead);
    upcomingMonday.setHours(0, 0, 0, 0);

    return upcomingMonday;
  };

  const getRegularWeek = (regularMatches) => {
    // Filter out all of the games that happened before this previous Monday
    // This will leave us with only the games for the current week.
    const filteredMatches = regularMatches.filter((game) => {
      const scheduledTime = new Date(game.scheduledTime);
      return scheduledTime > getPreviousMonday();
    });
    
    //TODO: Sort here for peace of mind? games should be ordered by week by default
    // If there are no filtered matchups, then just return the last week. Most likely playoffs haven't started
    return filteredMatches.length > 0 ? filteredMatches[0][constants.weekNumber] : regularMatches[regularMatches.length-1][constants.weekNumber];
  }

  const getPlayoffWeek = (weekList) => {}

  const filterWeeksForDropdown = (matchups, playoffMatches) => {
    let filteredWeeks = new Set();
    let playoffWeeks = new Set();
    let options = [];

    // Get each unique week
    matchups.forEach((matchup) => {
      if (matchup.hasOwnProperty(constants.weekNumber)){
        filteredWeeks.add(matchup[constants.weekNumber]);
      }
    });

    playoffMatches.forEach((matchup) => {
      if (matchup.hasOwnProperty(constants.weekNumber)){
        playoffWeeks.add(matchup[constants.weekNumber]);
      }
    });

    // Sort weeks
    const sortedWeeks = Array.from(filteredWeeks).sort((a,b) => {
      if (a < b) return 1
      if (a > b) return -1;
      return 0;
    });

    // Build playoff weeks, apologies for the slop
    const uniquePlayoffs = Array.from(playoffWeeks);
    const poRound1Count = playoffMatches.filter(m => m[constants.playoffs] && m[constants.weekNumber] == 1).length;
    let start = poRound1Count==8 ? 0 : poRound1Count==4 ? 1 : 2;

    uniquePlayoffs.forEach(m => {
      let option = {};
      option.key = "playoff" + m;
      option.value = "playoff" + m;
      option.label = constants.playoffRoundsShort[start];

      options.push(option);
      start++;
    })
    options.reverse();

    // Build array for dropdown select
    sortedWeeks.forEach((week) => {
      let option = {};
      option.key = "week" + week;
      option.value = week;
      option.label = "Week " + week;

      options.push(option);
    });

    return options; 
  }

  useEffect(() => {
    if (isLoading) return; // Wait for data from App.js
    
    const makeDashboardCalls = async () => {
      setIsLoading(true);
      try {
        const baseUrl = utils.getBaseUrl(leagueType);

        const playersResponse = await api.fetch(baseUrl, constants.uri.players(selectedDivision[constants.divisionId]));
        const teamsResponse = await api.fetch(baseUrl, constants.uri.standings(selectedDivision[constants.divisionId]));
        const matchupsResponse = await api.fetch(baseUrl, constants.uri.matchups(selectedDivision[constants.divisionId]));
        const playoffResponse = await api.fetch(baseUrl, constants.uri.matchups(selectedDivision[constants.divisionId]), "?playoffs=true");

        if (!playersResponse.hasOwnProperty([constants.values])) throw playersResponse;
        if (!teamsResponse.hasOwnProperty([constants.values])) throw teamsResponse;
        if (!matchupsResponse.hasOwnProperty([constants.values])) throw matchupsResponse;
        if (playoffResponse.hasOwnProperty('errors')) throw playoffResponse;

        const players = playersResponse[constants.values].map(p => ({
          ...p,
          [constants.fullName]: p[constants.firstName] + " " + p[constants.lastName],
          [constants.fullTeam]: (<div style={{display:'flex', flexDirection:'row', justifyContent:'flex-start', alignItems:'center', gap:'10px'}}>
                                  <img src={`/logos/${p[constants.clubLogo]}.png`} style={{height:'32px', width: '32px'}}/> {p[constants.teamName]}
                                 </div>)
        }));

        const teams = teamsResponse[constants.values].map(t => ({
          ...t,
          [constants.fullTeam]: (<div style={{display:'flex', flexDirection:'row', justifyContent:'flex-start', alignItems:'center', gap:'10px'}}>
                                  <img src={`/logos/${t[constants.clubLogo]}.png`} style={{height:'32px', width: '32px'}}/> {t[constants.teamName]}
                                 </div>)
        }));

      const regularMatchups = matchupsResponse[constants.values] ?? [];
      const playoffMatchups = playoffResponse[constants.values] ?? [];
      const combinedMatchups = [...regularMatchups, ...playoffMatchups];

      if (combinedMatchups.length === 0) {
        setAllWeeks([]);
        setAllMatchups([]);
        setSelectedWeek(1);
        setSelectedWeekMatchups([]);
      } else {
        const weekList = filterWeeksForDropdown(regularMatchups, playoffMatchups);

        const selectedWeek =
          playoffMatchups.length > 0
            ? weekList[0].value
            : getRegularWeek(regularMatchups);

        setAllWeeks(weekList);
        setAllMatchups(combinedMatchups);
        setSelectedWeek(selectedWeek);
        setSelectedWeekMatchups(filterMatchupsByWeek(combinedMatchups, selectedWeek));
      }

        setPlayerStandings(players);
        setTeamStandings(teams);
        setIsLoading(false);
      } 
      catch (err) {
        console.error(err);
        setDialog({
          title: err.title ? err.title : constants.messages.errorMessage, 
          code: err.status ? err.status : "N/A", 
          message: err.message, 
          isError: true});
        setIsLoading(false);
      }
    }

    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
    setSelectedMenuItem(constants.sidebarItems[0]);
    if (selectedDivision[constants.divisionId] != "") makeDashboardCalls();
  }, [selectedDivision])

  return (
    <div className={styles.Dashboard}>

      <div className={styles.Header}>
        <div className={styles.Title}>{constants.titles.dashboard}</div>
        <div className={styles.SubTitle}> {`${selectedLocation[constants.locationName]} ${selectedDivision[constants.divisionName]} DIVISION`}</div>
      </div>

      <hr className={styles.Spacer}/>

      {!isLoading ? <>
        <div className={styles.DashboardContainer}>
          <Matchups
            teamStandings={teamStandings}
            allMatchups={allMatchups}
            selectedWeekMatchups={selectedWeekMatchups}
            selectedWeek={selectedWeek}
            allWeeks={allWeeks}
            selectedLocation={selectedLocation}
            selectedDivision={selectedDivision}
            leagueType={leagueType}/>

          {/* Overview section */}
          <Overview 
            players={playerStandings} 
            teams={teamStandings} 
            setSelectedMenuItem={setSelectedMenuItem}/>
        </div> 
      </> : <LoadingSpinner/>}
    </div>
  )
}

export default Dashboard;